{
  "pipeline": {
    "enable": "Enable Pipeline",
    "enableDescription": "I want to set up secondary destinations for archiving.",
    "childBuckets": "Secondary Destinations",
    "bucketName": "Bucket Name"
  }
}
